// IMPORT PACKAGE REFERENCES
import React, { Fragment } from 'react';

import PropTypes from 'prop-types';

// COMPONENT
const renderList = analysisStats => (
    <table className="table table-hover">
        <thead>
            <tr>
                <th scope="col">Analysis Status</th>
                <th scope="col">Count</th>
            </tr>
        </thead>
        <tbody>
            {analysisStats.map(analysis => renderListItem(analysis.status, analysis.count))}
        </tbody>
        <tfoot>
            <tr>
                <td />
                <td className="text-right">
                    Total:{' '}
                    {analysisStats.reduce(
                        (accumulator, item) => accumulator + parseInt(item.count),
                        0
                    )}
                </td>
            </tr>
        </tfoot>
    </table>
);

const renderListItem = (status, count) => (
    <tr key={status}>
        <td>{status}</td>
        <td>{count}</td>
    </tr>
);

const CurrentAnalysisStatsTable = props => <Fragment>{renderList(props.analysisStats)}</Fragment>;

CurrentAnalysisStatsTable.propTypes = {
    analysisStats: PropTypes.array.isRequired,
};

export { CurrentAnalysisStatsTable };
